import { SchedulesListDataDetailsType } from "../../../../../../models/list/data"
import { SchedulesExportExcelFRM302Type } from "../../../../../../models/list/export"
import moment from "moment"
import { getTextYesNo } from "../../../../../../../../../utils/getTextYesNo"
import { convertDateExport } from "../../../../utils/getDate"

const getHourExport = (date?: string) =>
  date ? moment(date).utc().format("HHmm") : ""

export const convertDataExport = (
  data: SchedulesListDataDetailsType[],
): SchedulesExportExcelFRM302Type[] => {
  const _data: SchedulesExportExcelFRM302Type[] = []
  data.forEach((item) => {
    _data.push({
      arrivalCityName: item.arrivalCityName || item.arrivalCityNameOther,
      arrivalCountryName: item.arrivalCountryName,
      arrivalDay: convertDateExport(item.arrivalDateTime),
      arrivalTime: getHourExport(item.arrivalDateTime),
      departureCityName: item.departureCityName || item.departureCityNameOther,
      departureCountryName: item.departureCountryName,
      departureDay: convertDateExport(item.departureDateTime),
      departureFlightNumber: item.departureFlightNumber,
      departureTime: getHourExport(item.departureDateTime),
      transit: getTextYesNo(item.isTransit),
      transportationName: item.transportationName,
    })
  })
  return _data
}
